<navbar [isCasino]="this._UiHelper.isBetSlip"></navbar>
<div class="main-page">
  <div class="main-container" id="main-page">
    <ng-container *ngIf="this._UiHelper.isLeftMenu">
      <div class="main-container-left-side">
        <left-sport-menu-desktop></left-sport-menu-desktop>
      </div>
    </ng-container>
    <forgot-password></forgot-password>
    <router-outlet></router-outlet>
    <ng-container *ngIf="this._UiHelper.isBetSlip">
      <div class="main-container-right-side" id="mainContainerRightSide">
        <ng-container *ngIf="'isLiveStream' | getEnv">
          <live-stream-tv-component></live-stream-tv-component>
        </ng-container>
        <ng-container *ngIf="!isMobileView">
          <current-slip-core></current-slip-core>
        </ng-container>
        <ng-container *ngIf="'sideBannerTopWinner' | getEnv">
          <app-side-slider-top-winner></app-side-slider-top-winner>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <div class="footer" *ngIf="this._UiHelper.footerIsActive">
    <footer-component></footer-component>
  </div>
</div>
<ng-container *ngIf="this._DataHelper.currentSlipInfo.currentTotalRate === 0 || this._DataHelper.currentSlipInfo.currentTotalRate === 1; else oddActiveTemplate"> </ng-container>
<ng-template #oddActiveTemplate>
  <div class="odd-active-template-bar" [ngClass]="{ 'animate-bar': this._DataHelper.isSelectOdd, 'animate-bar-none': !this._DataHelper.isSelectOdd }">
    <div [ngClass]="{ 'animation-text': this._DataHelper.isSelectOdd }" class="bottom-navbar-item-text">
      {{ this._DataHelper.currentSlipInfo.currentTotalRate | oddFormat }}
    </div>
  </div>
</ng-template>

<div class="bottom-navbar">
  <bottom-navbar></bottom-navbar>
</div>
<ng-container *ngIf="isMobileView">
  <!--  *ngIf="isMobileView && !quickTippIsActive" => Test edilecek-->
  <bottom-dialog></bottom-dialog>
</ng-container>
<ng-container *ngIf="isMobileView">
  <match-detail-dialog></match-detail-dialog>
</ng-container>
<ng-container *ngIf="isMobileView">
  <ng-container>
    <quick-tipp *ngIf="quickTippIsActive" (closeQuickTippOutput)="closeQuickTippOutput($event)"></quick-tipp>
  </ng-container>
</ng-container>
<ng-container *ngIf="('birthdateBonusModal' | getEnv) && this._UiHelper.isBirthdateBonus">
  <birthdate-bonus-component></birthdate-bonus-component>
</ng-container>
